
export interface iActionType{
    type:number, 
    data:any|any[],
}

export interface Dictionary<T>{
	[idx:string]:T;
}


export interface Translation{
    campaignName:string;
    campaignTitle:string;
    clientTitle:string;
    campaignLabel:string;
    splashIntro:string[];
    sharebutton:string;
    embedbutton:string;
    emdedCopyTitle:string;
    embedCopy:string;
    copyToClipboard:string;
    scrollDown:string;
    clientUrl:string;
    campaignUrl:string;
    begin:string;
    informationCopy:string;
    exploreButton:string;
    embedCopyTitle:string;
    infoTitle:string;
    altText:string;
    valueMapDesc:string[];
    rotateInfo:string;
    selectionInfo: string;
    buttonTech: string;
    buttonUni: string;
    selectText: string;
}


export const INIT_TRANSLATIONS:Translation = { 
    campaignName:"",
    campaignTitle:"",
    clientTitle:"",
    campaignLabel:"",
    splashIntro:[],
    sharebutton:"",
    embedbutton:"",
    emdedCopyTitle:"",
    embedCopy:"",
    copyToClipboard:"",
    scrollDown:"",
    clientUrl:"",
    campaignUrl:"",
    begin:"",
    informationCopy:"",
    exploreButton:"",
    embedCopyTitle:"",
    infoTitle:"",
    altText:"",
    valueMapDesc:[],
    rotateInfo:"",
    selectionInfo:"",
    buttonTech: "",
    buttonUni: "",
    selectText: "",

}

export interface iNavData {
    key: string;
    label: string;
    parent: string;
    child?:iNavData[];
    url:string;

}
export interface graphData {
    key:string;
    label:string;
    parent:string;
    graphType:string;
    data:any[];
    copy: string;
    url:string;
    filters:any[];
    firstKey:string;
    requiresSecondaryFilters:boolean;

}

export interface lineData {
    key:string;
    label:string;
    value:number;
    year:number;
    color:string;
}

export interface TreeDataObj {
    category: string;
    key: string;
    label: string;
    value: number;
}
